<template>
    <page-view title="查看催办单详情">
        <workflow-menu slot="xwfMenu" @onLoadXWFState="onLoadXWFState"/>
        <template slot="action">
<!--            <a-button type="primary" @click="doSimpleHandRounded">办结并关闭</a-button>-->
        </template>
        <a-card class="card">
            <div>
                <table class="fx-form-view">
                    <col width="120px"/>
                    <col/>
                    <col width="120px"/>
                    <col/>
                    <tr>
                        <th>发出人</th>
                        <td>
                            {{initData.extras.createUser}}
                        </td>
                        <th>发出时间</th>
                        <td>
                            <div>{{initData.createdAt}}</div>
                        </td>
                    </tr>
                    <tr>
                        <th>经办人</th>
                        <td>
                            {{initData.extras.handler}}
                        </td>
                        <th>办理期限</th>
                        <td>
                            <div>{{initData.newDeadline}}</div>
                        </td>
                    </tr>
                    <tr>
                        <th>说明事项</th>
                        <td colspan="3">
                            <div>{{initData.explain}}</div>
                        </td>
                    </tr>
                    <tr>
                        <th>进展情况</th>
                        <td colspan="3">
                            <div>{{initData.hint}}</div>
                        </td>
                    </tr>
                </table>
            </div>
        </a-card>
        <workflow-comment :xwfState="xwfState" />
    </page-view>
</template>

<script>
import { PageView } from '@/layouts'
import WorkflowMenu from '@/components/workflow/WorkflowMenu'
import WorkflowComment from '@/components/workflow/WorkflowComment'

export default {
  name: 'WorkflowUrgencyView',
  inject: ['reload'],
  components: {
    PageView,
    WorkflowMenu,
    WorkflowComment
  },
  created () {
    console.log('kdkdkaldfjas')
    this.loadData()
  },
  data () {
    return {
      xwfState: {},
      loading: false,
      form: this.$form.createForm(this),
      initData: {
        id: this.$route.query.id,
        extras: {}
      }
    }
  },
  methods: {
    onLoadXWFState (xwfState) {
      this.xwfState = xwfState
    },
    loadData () {
      let that = this
      this.$http.get('/api/1/workflow/get_urgency_process.json?id=' + this.initData.id).then(function (response) {
        let result = response.result
        that.initData = result
      })
    },
    doSimpleHandRounded () {
      let that = this
      that.loading = true
      this.$http.post('/api/2/workflow/urgency/simple_handround_action.json?id=' + this.initData.id).then(function (response) {
        that.loading = false
        if (response.code === 200) {
          that.reload()
          that.$message.success('已阅办理完毕')
        }
      })
    }
  }
}
</script>

<style scoped>
    .card {
        margin-bottom: 24px;
    }

    table .ant-form-item {
        margin-bottom: 0;
    }
</style>
